module.exports = __webpack_public_path__ + "img/n6-bg3.d2163663.png";